// Adobe RGB: 0.778, 0.377, 0.405
export const PRIMARY_COLOR = "#C66067";
// Adobe RGB: 0.438, 0.681, 0.722
export const SECONDARY_COLOR = "#70AEB8";

export const EVENT_NAME = "North America: DIGITAL TWIN 2026";
export const EVENT_LOCATION = "CHICAGO, USA";
export const CONFERENCE_DATE = "AUGUST 11, 2026";
export const WORKSHOPS_DATE = "AUGUST 12, 2026";
export const EVENT_WEBSITE = "https://usa.digitaltwin-summit.com";

export const apiToken =
  "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudElkIjoiOWY3MGZlMzQtN2Q0Yi0xMWVkLWExZWItMDI0MmFjMTIwMDI1IiwiY3VzdG9tZXJJZCI6ImQxYjkxMGZhLTMxYTgtMTFlZC1hMjYxLTAyNDJhYzEyMDAwMiIsImhvc3QiOiJodHRwczovL2VnLmRpZ2l0YWx0d2luLXN1bW1pdC5jb20iLCJpYXQiOjE3MzE1MDc3MTEsImF1ZCI6ImV4cC5jb20iLCJpc3MiOiJleHAtcHJvdmlkZXIiLCJzdWIiOiJhZG1pbkBleHAuY29tIn0.baMM3WygUlwyPbizcl44QMjZySRjyp2ap6Y_1CTNHf1Jog1YXRmoU7O-fnbiGOXOSjti8Nv4J-QHYdbFLreKOPcZa0d-lLlSH_m8rH4kVyzGSnWMbC-Zc4-XFZCVOQXm5Zub85d1t0MsV9fT1ANHphnJLW2VEfzBRBDWx0tnPx8";

export const newToken =
  "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudElkIjoiZDllMDMzMzItMWQ1NS0xMWVlLWJlNTYtMDI0MmFjMTIwMDI3IiwiY3VzdG9tZXJJZCI6ImQxYjkxMGZhLTMxYTgtMTFlZC1hMjYxLTAyNDJhYzEyMDAwMiIsImhvc3QiOiJodHRwczovL2VnLmRpZ2l0YWx0d2luLXN1bW1pdC5jb20iLCJpYXQiOjE3NjkwNzMzNzAsImF1ZCI6ImV4cC5jb20iLCJpc3MiOiJleHAtcHJvdmlkZXIiLCJzdWIiOiJhZG1pbkBleHAuY29tIn0.XozvvuygWJbAp5-my6hC0rJxTjUJJQYw2CVJvOX1sG0uUYUkHewr6VS17BsRTRw7Kmp86p0aCunaUHoh3THh5PkLU1fUVgMs-YVlaLqe7nhJemJt_6Xy9W4lMwkbzP4IGaFy9mL2fC7mD-pWtbu9TQ7SiupX6yrx29sjtEusPYI";

export const apiUrl = "https://api.rapid-events.com";
